//messages.js
export default {
	log_id: "Log Id",
	template_id: "Template Id",
	slug: "Slug",
	frequency: "Frequency",
	minutes: "Minutes",
	capture: "Capture",
	machine_id: "Machine Id",
	part_id: "Part Id",
	supervisor_id: "Supervisor Id",
	notes: "Notes",
	file_id: "File Id",
	version: "Version",
	active: "Active",
	edit_log: 'Edit Log',
	add_log: 'Add Log',
	delete_log: 'Delete Log',
	logs: 'Logs',
	delete_log_confirm: 'This action is not reversible!',
}